import bootstrap from '../assets/bootstrap.png'
import css from '../assets/css.svg'
import express from '../assets/Expressjs.png'
import figma from '../assets/figma.png'
import html from '../assets/html.png'
import js from '../assets/js.png'
import mui from '../assets/mui.png'
import nodejs from '../assets/nodejs.png'
import postgresql from '../assets/postgresql.png'
import react from '../assets/react.png'
import redux from '../assets/redux.png'
import sass from '../assets/sass.png'
import sequelize from '../assets/sequelize.png'

const skillsArr = [
    {
        id: 9,
        name: 'React',
        logo: react
    },
    {
        id: 10,
        name: 'Redux',
        logo: redux
    },
    {
        id: 2,
        name: 'CSS',
        logo: css
    },
    {
        id: 5,
        name: 'HTML',
        logo: html
    },
    {
        id: 6,
        name: 'JS',
        logo: js
    },
    {
        id: 1,
        name: 'Bootstrap',
        logo: bootstrap
    },
    {
        id: 11,
        name: 'SASS',
        logo: sass
    },
    {
        id: 4,
        name: 'Figma',
        logo: figma
    },
    {
        id: 7,
        name: 'Material UI',
        logo: mui
    },
    {
        id: 3,
        name: 'Express',
        logo: express
    },
    {
        id: 8,
        name: 'PostgreSQL',
        logo: postgresql
    },
    {
        id: 12,
        name: 'Sequelize',
        logo: sequelize
    },
    {
        id: 13,
        name: 'Node.js',
        logo: nodejs
    },
]

export default skillsArr